<template>
  <div>
    <div v-if="location && !loadingItems">
      <h1 class="title has-text-centered">{{ location.label }}</h1>
      <div>
        <img style="width: 100%;" :src="locationImageUrl(location)" />
      </div>

      <h5 v-if="location.items.length || location.npcs.length" class="title is-6 mt-5">Featuring:</h5>
      <div v-if="location.npcs.length">
        <small-items-list :items="location.npcs" type="inhabitants" has-quantity />
      </div>

      <div v-if="location.items.length" :class="`${location.npcs.length ? 'mt-4' : ''}`">
        <small-items-list :items="location.items" type="items" has-quantity />
      </div>

      <div v-if="Object.keys(location.connections).length > 0" class="mt-6">
        <h5 class="title is-6">{{ location.label }} connects to:</h5>

        <div class="columns is-multiline">
          <div
            class="column is-4 content"
            v-for="region in Object.keys(location.connections)"
            :key="region"
          >
            <strong><router-link :to="`/encyclopedia/locations/${region}`">{{ regionNameById(region) }}</router-link></strong>

            <ul class="mt-3">
              <li v-for="location in location.connections[region]" :key="location.id">
                <router-link :to="`/encyclopedia/locations/${region}/${location.id}`">{{ location.label }}</router-link>
              </li>
            </ul>
          </div>
        </div>

      </div>

      <div v-if="location.notes.length" class="mt-6">
        <h5 class="title is-6">Notes left by Oddlings:</h5>

        <div class="is-relative custom-panel">
          <div class="feed-item-container" v-for="note in location.notes" :key="note.id">
            <div class="feed-item-avatar has-text-centered mr-4">
              <username :show-name="false" :user="note.user" />
            </div>
            <div class="feed-item-content">
              <username :show-avatar="false" :user="note.user" /> wrote:
              <div class="mt-3">{{ note.note }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="false" v-model="loadingItems"></b-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getEncyclopediaImageUrl } from '@/services/encyclopedia';
import SmallItemsList from '@/components/Encyclopedia/SmallItemsList.vue';
import Username from '../../components/Forum/Username.vue';

export default {
  name: 'LocationDetails',
  components: { Username, SmallItemsList },
  metaInfo() {
    return {
      title: `${this.location?.label || 'Location'}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.location?.label || 'Location'} - Odd Giants Game locations encyclopedia`,
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'encyclopedia, locations, groddle, forest, streets, resources, vendors, odd, giants, glitch, game, remake, multiplayer, online, mmorpg',
        },
      ],
    };
  },
  props: {
    regionId: String,
    locationId: String,
  },
  computed: {
    ...mapState('encyclopedia', ['loadingItems', 'location', 'categories']),
    relatedLocations() {
      if (!this.location) {
        return [];
      }

      return [
        ...this.location.connections_from,
        ...this.location.connections_to,
      ];
    },
  },
  mounted() {
    this.loadItem(this.locationId);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadItem(to.params.locationId);
    next();
  },
  methods: {
    regionNameById(regionId) {
      if (!this.categories || !this.categories.locations) {
        return '';
      }

      return this.categories.locations.categories.find((category) => category.id === regionId).name;
    },
    locationImageUrl(location) {
      return getEncyclopediaImageUrl('locations', location.id);
    },
    async loadItem(locationId) {
      await this.$store.dispatch('encyclopedia/loadLocationDetails', locationId);
    },
  },
};
</script>
